export class DocumentNotFoundError extends Error {
  readonly code = "document-not-found";

  constructor(path: string) {
    super(`Document not found at path: ${path}`);
    this.name = "DocumentNotFoundError";
  }
}
